import { Injectable } from '@angular/core';

@Injectable()
export class CompanyEffects {

  // @Effect()
  // loadCompanyState$: Observable<Action> = this.actions$
  //   .ofType(CompanyActionTypes.LoadCompanyState)
  //   .startWith(new LoadCompanyState())
  //   .switchMap(() =>
  //   // You can pull from offline state here or get data from a server via an api
  //   // An example of inserting data into offline state can be found in login.effects.ts
  //     this.db.query('company')
  //       .map((state: ICompany) => new LoadCompanyStateSuccess(state))
  //       .catch(error => Observable.of(new LoadCompanyStateFail(error)))
  //   );

}